<template>
  <div :id="id" :style="style"></div>
</template>

<script>
export default {
  name: "Chart",
  data() {
    return {
      chart: null
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "480px"
    },
    option: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    style() {
      return {
        height: this.height,
        width: this.width
      };
    }
  },
  watch: {
    option: {
      handler(newVal, oldVal) {
        if (this.chart) {
          if (newVal) { 
            this.chart.setOption(newVal); 
          } else {
            this.chart.setOption(oldVal);
          }      
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option);
      window.addEventListener("resize", this.chart.resize);
    }
  }
};
</script>
